export const ADMIN_BASE_PATH = "/director";

export const ADMIN_PATH_PREFIXES = ["/director", "/cto", "/webmaster", "/admin"];

export function isAdminPath(pathname = "") {
  const path = pathname.toLowerCase();
  return ADMIN_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function adminPath(path = "") {
  return `${ADMIN_BASE_PATH}${path}`;
}
